import { CodePrestation } from './../codes/code-prestation';
import { IMaladieAccident, IGetOneMaladie } from './imaladie';
import { Prestation } from './prestation';

export class Jour {

  public Day: number;
  public Date: Date;
  public DureeJourTheo: number;
  public DureeJour: number;
  public Prestations: Prestation[];
  public Maladie: IGetOneMaladie;
  public AvecPointage: boolean;
  public AvecMaladie: boolean;
  public CleMaladie: number = 0;

  constructor() {
    this.Day = 0;
    this.DureeJour = 0;
    this.DureeJourTheo = 0;
    this.Prestations = [];
    this.AvecPointage = false;
    this.AvecMaladie = false;
  }
}
